export default __webpack_public_path__ + "static/media/AsistenciaUsuarios.0ac2c897.svg";